module.exports = __webpack_public_path__ + "static/media/heart-solid.ef8e6f5f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/vectors/heart-solid.svg
// module id = 209
// module chunks = 0